import { Drawer } from '@mui/material';
import { useRef } from 'react';

import { IssueCard } from '../IssueCard/IssueCard';
import { useIssueDrawer } from '../../useIssueDrawer';

/** Глобальная карточка задачи: выезжает справа поверх любого экрана трекера */
const IssueDrawer = () => {
  const { issueKey, closeIssue } = useIssueDrawer();
  // Держим последний ключ, чтобы карточка не пропадала во время анимации закрытия
  const shownKey = useRef(issueKey);

  if (issueKey) shownKey.current = issueKey;

  return (
    <Drawer
      anchor="right"
      open={!!issueKey}
      onClose={closeIssue}
      slotProps={{ paper: { sx: { width: 'min(1040px, calc(100vw - 64px))' } } }}
    >
      {shownKey.current && (
        <IssueCard key={shownKey.current} issueKey={shownKey.current} onClose={closeIssue} />
      )}
    </Drawer>
  );
};

export { IssueDrawer };
